import { useCallback, useState } from 'react';
import api from '../api';

interface UseCheckOwnerSalesforceIdAvailabilityResult {
  isLoading: boolean;
  error: string | null;
  isAvailable: boolean | null;
  checkSalesforceId: (salesforceId: string) => Promise<void>;
}

export default function useCheckOwnerSalesforceIdAvailability(): UseCheckOwnerSalesforceIdAvailabilityResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null);

  const checkSalesforceId = useCallback(async (salesforceId: string) => {
    setIsLoading(true);
    setError(null);
    setIsAvailable(null);
    try {
      const result = await api.checkOwnerSalesforceIdAvailability(salesforceId);
      // Expecting API to return { available: boolean }
      setIsAvailable(Boolean(result?.available));
    } catch (err: unknown) {
      const errorMessage =
        err instanceof Error ? err.message : 'Failed to check Salesforce ID availability';
      setError(errorMessage);
      setIsAvailable(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, error, isAvailable, checkSalesforceId };
}
